import type { Action, AnyAction, Dispatch } from '@reduxjs/toolkit';
import {
  fetchAdvisorHierarchyRelationshipsByAdvisorIdRequest,
  postAdvisorHierarchyInvitationByAdvisorIdResponse,
  deleteAdvisorHierarchyRelationshipByAdvisorIdResponse,
  postAdvisorHierarchyInvitationAcceptByInvitationIdResponse,
  postAdvisorHierarchyInvitationDeclineByInvitationIdResponse,
} from './advisorHierarchyModel';
import { AppState } from './store';
import { createSimpleMiddleware } from './createSimpleMiddleware';
import { isNullOrUndefined } from '@shared/isNullOrUndefined';

/**
 * Middleware to invalidate & refetch advisor hierarchy relationships when mutations complete
 */
function invalidateAdvisorHierarchyMiddlewareImpl(
  dispatch: Dispatch<AnyAction>,
  getStore: () => AppState,
  next: Dispatch<AnyAction>,
  action: Action<string>,
) {
  next(action);

  if (
    action.type === postAdvisorHierarchyInvitationByAdvisorIdResponse.type ||
    action.type === deleteAdvisorHierarchyRelationshipByAdvisorIdResponse.type ||
    action.type === postAdvisorHierarchyInvitationAcceptByInvitationIdResponse.type ||
    action.type === postAdvisorHierarchyInvitationDeclineByInvitationIdResponse.type
  ) {
    setTimeout(() => fetchAdvisorHierarchyRelationships(dispatch, getStore));
  }
}

export const invalidateAdvisorHierarchyMiddleware = createSimpleMiddleware(
  invalidateAdvisorHierarchyMiddlewareImpl,
);

function fetchAdvisorHierarchyRelationships(
  dispatch: Dispatch<AnyAction>,
  getStore: () => AppState,
) {
  const state = getStore();

  const advisorId = state.session.advisor?.advisorId;

  if (!isNullOrUndefined(advisorId)) {
    dispatch(
      fetchAdvisorHierarchyRelationshipsByAdvisorIdRequest({
        advisorId,
      }),
    );
  }
}
